import { useMemo } from "react";
import { useCollapse } from "react-collapsed";
import { collapseKey, optimistActions, useOptimistReportDispatch, useOptimistReportSelector, } from "./state";
export const COLLAPSE_DURATION = 300;
export function usePanelCollapse(creditManager, creditAccount) {
    const isExpanded = useOptimistReportSelector(state => {
        const key = collapseKey(creditManager, creditAccount);
        return !!state.collapsedPanels[key];
    });
    const dispatch = useOptimistReportDispatch();
    const { getCollapseProps, getToggleProps } = useCollapse({
        isExpanded,
        duration: COLLAPSE_DURATION,
    });
    return useMemo(() => ({
        toggleProps: getToggleProps({
            onClick: () => dispatch(optimistActions.togglePanelCollapse({
                creditManager,
                creditAccount,
            })),
        }),
        collapseProps: getCollapseProps(),
        collapsed: !isExpanded,
        toggleExpanded: () => optimistActions.togglePanelCollapse({
            creditManager,
            creditAccount,
        }),
    }), [
        isExpanded,
        dispatch,
        getCollapseProps,
        getToggleProps,
        creditManager,
        creditAccount,
    ]);
}
